import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { AppRoute } from '../app.routes.fixtures'
import { SettingsService } from '../services/settings/settings.service'

/**
 *  Redirect to correct home-path depending on platform
 */
export const HomeGuard: CanActivateFn = (_route, _state) => {
  const settingsService = inject(SettingsService)
  const router = inject(Router)

  var route = _state.url

  if (route.includes(`/${AppRoute.home}/`)) {
    const path = settingsService.isMobile
      ? AppRoute.homeTabs
      : AppRoute.homeMenu
    route = route.replaceAll(`/${AppRoute.home}/`, `/${path}/`)
    return router.navigate([route])
  }

  if (settingsService.isMobile && route.includes(AppRoute.homeMenu)) {
    route = route.replaceAll(AppRoute.homeMenu, AppRoute.homeTabs)
    return router.navigate([route])
  } else if (!settingsService.isMobile && route.includes(AppRoute.homeTabs)) {
    route = route.replaceAll(AppRoute.homeTabs, AppRoute.homeMenu)
    return router.navigate([route])
  }

  return true
}
